export default __webpack_public_path__ + "static/media/moon.76be552e.webp";